// How a human display name becomes a machine identifier — the one shared slug
// transform (see ./identifier.ts). Re-exported so every product imports it from
// one canonical place.
export { deriveIdentifier, sanitizeIdentifierInput, normalizeIdentifier, isValidIdentifier, identifierRule, } from './identifier.js';
// Axis B — per-product user scopes (user_product_scope.scope). The DB column is
// free text by design; THIS catalogue is the app-layer validation source, so the
// vocabulary lives in exactly one place (it was previously copied across both
// member-PATCH zod enums, the invites input type, and two SPA lists). Only
// callcenter has live per-user scopes today; a product joins by adding its row
// here + a requireProductRole gate reading JwtClaims.productScopes — see
// design/roles-and-access.md.
export const PRODUCT_SCOPES = {
    // 'agent' = call taker (agent UI only); 'supervisor' = nearly an admin;
    // 'admin' = call-centre product admin. Absent = no CC access.
    callcenter: ['agent', 'supervisor', 'admin'],
};
// The one product excluded from every Workspace product-catalog surface (the
// launcher + the v1 app-switcher): callcenter is DESK-ONLY — the Agent's desk +
// Console configuration, never a tenant-user Workspace app (three surfaces, three
// people). The exclusion literal was copied verbatim into two workspace queries;
// this is the single source they both bind as a parameter.
export const DESK_ONLY_PRODUCT_ID = 'callcenter';
// S2S HTTP envelope (contracts §2) — header names + the caller-side stamping
// function single-sourced in ./envelope so the caller side (@retink/clients,
// @retink/server) and the callee side (requireServiceToken) can't drift.
export { TENANT_HEADER, INTERACTION_HEADER, IDEMPOTENCY_HEADER, REQUEST_ID_HEADER, TRACEPARENT_HEADER, newTraceparent, stampEnvelope, } from './envelope.js';
// The agent contract (contracts §4) — the immutable published agent snapshot
// agents writes and the flow engine reads at flow publish. Homed here (audit fix E).
// `REASONING_EFFORTS` is the runtime tuple (the ONE source; agents' zod enum pins to it).
export { REASONING_EFFORTS, AGENT_TYPES } from './agent.js';
// Tag-based Prompt (track 05) — the shared pure compose/mermaid seam + its types.
export { PROMPT_TAGS, EDITABLE_PROMPT_TAGS, PROCESS_NODE_TYPES, toMermaid, renderProcessesRegion, composeInstructions, parseSections, } from './agent.js';
// The conversation_event `type` vocabulary (contracts §4) — the closed canon the
// S2S append surface validates and every producer/reader binds to.
export { CONVERSATION_EVENT_TYPES } from './conversation-event.js';
//# sourceMappingURL=index.js.map